module.exports = "<div ui-view=main></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/crm/accounts/accounts.html
// module id = 395
// module chunks = 0